import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http'
import { CorteUsuario } from '../models';
import { environment } from 'src/environments/environment';
import { CorteActual } from '../models/dash';
import {ToastrService} from 'ngx-toastr';
import { FormGroup } from '@angular/forms';
import {tap} from 'rxjs/operators';
import {forkJoin} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CorteService {

  private ENDPOINT = environment.ENDPOINTS.CORTEUSUARIO;
  private ENDPOINTACTUAL = environment.ENDPOINTS.CORTEACTUAL;
  private ENDPOINTINSTALL = environment.ENDPOINTS.INSTALACION;
  private ENDPOINTCORTEUSER = environment.ENDPOINTS.CORTEUSERS;
  private ENDPOINTUSERCORTE = environment.ENDPOINTS.USUARIO_GENERA_FALTANTE;
  private ENDPOINTPDF = environment.ENDPOINTS.PDF;
  private REPORTES_ANALISTA = environment.ENDPOINTS.REPORTES_ANALISTA;
  private ENDPOINTPDFPRELIQUIDACION = environment.ENDPOINTS.PRELIQUIDACION;
  private ENDPOINTACTAPDF = environment.ENDPOINTS.ACTAADMINISTRATIVAPDF;
  private ENDPOINT_CATOBSERVACION = environment.ENDPOINTS.CATOBSERVACION;
  constructor(private http:HttpClient, private toastrService: ToastrService) { }

  getCatalogos() {
            const comentario$ = this.http.get(`${this.ENDPOINT_CATOBSERVACION}/comentario`);
        const retornoProvenencia$ = this.http.get(`${this.ENDPOINT_CATOBSERVACION}/retorno-provenencia`);

        forkJoin([comentario$, retornoProvenencia$]).pipe(
          tap(([comentarioData, retornoProvenenciaData]) => {
            localStorage.setItem('catObservacionComentario', JSON.stringify(comentarioData));
            localStorage.setItem('catObservacionRetornoProvenencia', JSON.stringify(retornoProvenenciaData));
          })
        ).subscribe({
          error: err => {
            console.error('Error cargando cat observacion:', err);
          }
        });
    }
  saveCorteUsuario(corteUsuario){

    let id_carril = Number(localStorage.getItem("id_carril"));
    if(!id_carril) {
      this.toastrService.error('No se ha configurado la cabina', '', {positionClass: 'toast-bottom-right'});
      return null;
    }

    return this.http.post<CorteUsuario[]>(this.ENDPOINT, {...corteUsuario, id_carril});
  }

  getCorteUsuario(){
    return this.http.get<CorteUsuario[]>(this.ENDPOINT);
  }

  getCortesPagados(id_usuario : number){
    return this.http.get<CorteUsuario[]>(this.ENDPOINT+ `/get-corte-pagados/${ id_usuario }`);
  }

  getCorteUsuarioFromJT(id_usuario){
    return this.http.get<CorteUsuario[]>(this.ENDPOINT+ `/get-corte-usuario-by-jt/${ id_usuario }`);
  }

  getCortesPreliquidadoByJT(id_usuario : number){
    return this.http.get<CorteUsuario[]>(this.ENDPOINT+ `/get-cortes-preliquidado-jt/${ id_usuario }`);
  }

  getCortePreliquidadoByJT(id_corte_usuario : number){
    return this.http.get<CorteUsuario[]>(this.ENDPOINT+ `/get-corte-preliquidado-jt/${ id_corte_usuario }`);
  }

  getCorteActual(id_jefe_turno: number, id_caseta: number) {
    return this.http.get<CorteActual[]>(this.ENDPOINTACTUAL+`/${ id_jefe_turno }/${ id_caseta }`);
  }

  saveAsignarCarril( data: any ) {
    return this.http.post(this.ENDPOINT +'/asignar-carril', data)
  }

  savePreliquidacionCorte( data: any ) {
    return this.http.post(this.ENDPOINT +'/save-preliquidacion-corte', data)
  }

  saveStatusCortes( data: any ) {
    return this.http.post(this.ENDPOINT +'/save-status-cortes', data)
  }

  getCobradorFormacion( id_caseta: number, id_usuario: number, id_turno: number) {
    return this.http.get<any[]>(this.ENDPOINT + `/cobrador-formacion/${ id_caseta }/${ id_usuario }/${ id_turno }`);
  }

  saveStartTurn(idCorte : number){
    return this.http.put(`${this.ENDPOINT}/start-turn/${idCorte}`, {});
  }

  checkInstalacion(idCaseta : number) {
    return this.http.get(`${this.ENDPOINTINSTALL}/${ idCaseta }`);
  }

  getCortesUser(id_usuario : number) {
    return this.http.get(`${this.ENDPOINTCORTEUSER}/${ id_usuario }`);
  }

  getUsersCortes(id_caseta: number, id_turno: number) {
    return this.http.get(`${ this.ENDPOINTUSERCORTE }/${ id_caseta }/${ id_turno }`);
  }

  getSumaCorte(id_corte_usuario : number) {
    return this.http.get(`${ this.ENDPOINT }/suma-by-corte/${ id_corte_usuario }`);
  }

  getCorteTurnoUsuarios(id_caseta: number, id_turno: number) {
    return this.http.get<any[]>(`${ this.ENDPOINT }/get-cortes-usuarios/${ id_caseta }/${ id_turno }`)
  }

  getCorteFormatoHeader(id_caseta: number, id_carril: number, id_turno: number, fecha: any) {
    return this.http.get<any[]>(`${ this.ENDPOINT }/get-cortes-header/${ id_caseta }/${ id_carril }/${ id_turno }/${ fecha }`);
  }
  getCasetas() {
    return this.http.get<any[]>(`${ this.ENDPOINT }/casetas`);
  }

  getCorteRetiros(id_corte_usuario: number) {
    return this.http.get<any[]>(`${ this.ENDPOINT }/get-formato-retiro/${ id_corte_usuario }`);
  }

  getCorteExentos(id_corte_usuario: number) {
    return this.http.get<any[]>(`${ this.ENDPOINT }/get-formato-exento/${ id_corte_usuario }`);
  }
  getFallasCorte(id_corte_usuario: number) {
    return this.http.get<any[]>(`${ this.ENDPOINT }/get-formato-fallas/${ id_corte_usuario }`);
  }
  getRetornosCorte(id_corte_usuario: number) {
    return this.http.get<any[]>(`${ this.ENDPOINT }/get-formato-retornos/${ id_corte_usuario }`);
  }
  getCorteIncidencia(id_corte_usuario: number) {
    return this.http.get<any[]>(`${ this.ENDPOINT }/get-formato-incidencia/${ id_corte_usuario }`);
  }

  getCorteCorte(id_corte_usuario: number) {
    return this.http.get<any[]>(`${ this.ENDPOINT }/get-formato-corte/${ id_corte_usuario }`);
  }
  getCorteReporteFallas(data: any) {
    return this.http.post<any[]>(`${ this.ENDPOINT }/get-formato-reportefallas`, data);
  }

  //FORMATO PDF
  getDataReporte(data:any){
    let { download } = data;
    if (download) {
      const httpOptions = {responseType: 'blob' as 'json'};
      return this.http.post(`${ this.ENDPOINTPDF }`,data, httpOptions).toPromise();
    } else {
      return this.http.post(`${ this.ENDPOINTPDF }`,data, { responseType: 'text'}).toPromise();
    }

  }
  getDataReporteAnalista(data:any){
      const httpOptions = {responseType: 'blob' as 'json'};
      return this.http.post(`${ this.REPORTES_ANALISTA }`,data, httpOptions).toPromise();
  }

  // PDF PRELIQUIDACION
  getPDFPreliquidacion(data:any){
    const httpOptions = {responseType: 'blob' as 'json'};
    return this.http.post(`${ this.ENDPOINTPDFPRELIQUIDACION }`,data, httpOptions).toPromise();
  }

  getPDFActaAdministrativa(data:any){
    const httpOptions = {responseType: 'blob' as 'json'};
    return this.http.post(`${ this.ENDPOINTACTAPDF }`,data, httpOptions).toPromise();
  }
 //ANALISTA
  getCorteIncidencias(data:FormGroup) {
    return this.http.post<any>(`${ this.ENDPOINT }/getIncidenciasAnalista/`,data );
  }
  getExentos(data:FormGroup) {
    return this.http.post<any[]>(`${ this.ENDPOINT }/getExentos/`, data);
  }
  getCorteCorteAnalista(data:FormGroup) {
    return this.http.post<any[]>(`${ this.ENDPOINT }/getCorteAnalista/`, data);
  }
  getCorteRetirosAnalista(data:FormGroup) {
    return this.http.post<any[]>(`${ this.ENDPOINT }/getRetirosAnalista/`, data);
  }
  actualizarObservacionEvento(data:FormGroup) {
    return this.http.post<any[]>(`${ this.ENDPOINT }/actualizarObservacionEvento/`, data);
  }

  getCortesUsedJT(data:any){
    return this.http.post<CorteUsuario[]>(`${ this.ENDPOINT }/get-cortes-used-jt`, data);
  }
  cortesPorFechaCasetaTurno(data:any){
    return this.http.post<CorteUsuario[]>(`${ this.ENDPOINT }/cortesPorFechaCasetaTurno`, data);
  }

}
